import { ChevronIcon } from "shared/components/Icons";
import { MaxWidth } from "shared/components/MaxWidth";
import { onlyLinkSerializers } from "shared/components/Content";
import { RichText } from "shared/components/RichText";
import { SMALL, TYPE_RICHTEXT_SIMPLE } from "shared/utils/constants";
import { translate, COLLAPSE, EXPAND } from "shared/utils/translate";
import { useRouter } from "next/router";
import { useState } from "react";
import BlockContent from "@sanity/block-content-to-react";
import cx from "classnames";
import styles from "./Expandables.module.css";

export const ExpandablesContainer = ({ title, items, size = SMALL }) => (
  <div className="ExpandablesContainer">
    <MaxWidth size={size}>
      <Expandables title={title} items={items} />
    </MaxWidth>
  </div>
);

export const Expandables = ({ title, items }) => (
  <>
    {title && (
      <RichText>
        <h2 className={styles.sectionTitle}>{title}</h2>
      </RichText>
    )}
    {items.map(({ title, text }) => (
      <Expandable key={title} text={text} title={title} />
    ))}
  </>
);

const Expandable = ({ text, title }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { locale } = useRouter();

  return (
    <div className={cx(styles.item, { [styles.isOpen]: isOpen })}>
      <div className={styles.header} onClick={() => setIsOpen(!isOpen)}>
        <h3 className={styles.title}>{title}</h3>
        <button
          type="button"
          className={styles.button}
          aria-expanded={isOpen}
          aria-label={translate(isOpen ? COLLAPSE : EXPAND, locale)}
          onClick={() => setIsOpen((isOpen) => !isOpen)}
        >
          <ChevronIcon />
        </button>
      </div>
      <div className={styles.content}>
        <RichText type={TYPE_RICHTEXT_SIMPLE}>
          <BlockContent blocks={text} serializers={onlyLinkSerializers} />
        </RichText>
      </div>
    </div>
  );
};
